(function() { module.exports = this["wp"]["tokenList"]; }());